export const EQUIPMENT_ADD_CONFIRM_MODAL = {
  TITLE: 'Equipment has been successfully added',
}
